import React, { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate, useLocation } from 'react-router-dom';
import topGradient from '@/assets/top-gradient.png';
import logoDark from '@/assets/logo-dark.png';
import '../styles.css';
import { PANEL_ADMIN_USERS } from '../components/PanelRoute';

const PANEL_AUTH_KEY = 'panel:auth';

const Login: React.FC = () => {
  const { user } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const allowed = PANEL_ADMIN_USERS.includes(user.id);
      if (allowed) {
        try { localStorage.setItem(PANEL_AUTH_KEY, 'true'); } catch { }
        const search = new URLSearchParams(location.search);
        const redirect = search.get('redirect');
        navigate(redirect || '/panel', { replace: true });
      } else {
        setError('Acceso denegado');
        try { localStorage.removeItem(PANEL_AUTH_KEY); } catch { }
      }
    }
  }, [user, navigate, location.search]);

  const handleLogin = async () => {
    try {
      setBusy(true);
      const redirectTo = `${window.location.origin}/panel/login`;
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo }
      });
      if (error) throw error;
    } catch (e: any) {
      setBusy(false);
      setError(e?.message || 'No se pudo iniciar sesión');
    }
  };

  return (
    <div className="relative min-h-screen bg-white overflow-hidden panel-font">
      {/* top gradient background */}
      <img src={topGradient} alt="" className="pointer-events-none select-none absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl" />
      <img src={topGradient} alt="" className="pointer-events-none select-none absolute bottom-0 rotate-180 left-1/2 -translate-x-1/2 w-full max-w-4xl" />

      {/* brand */}
      <div className="relative z-10 flex items-center justify-center pt-10">
        <a href="https://bloomkeep.site" target="_blank" rel="noreferrer">
          <img src={logoDark} alt="BloomKeep" className="h-24 w-auto" />
        </a>
      </div>

      {/* content */}
      <div className="relative z-10 flex items-center justify-center min-h-[60vh] px-6">
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-slate-800 mb-6">Panel de Control</h1>
          <button
            onClick={handleLogin}
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-xl px-5 py-3 text-white font-medium panel-cta"
          >
            {busy ? 'Redirigiendo…' : 'Acceder con Google'}
          </button>
          {error && (
            <p className="mt-4 text-sm text-red-600">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
